import { CalendarIcon } from '@heroicons/react/24/outline'

export default function Timeline({ events = [] }) {
  return (
    <section className="py-16">
      <div className="max-w-3xl mx-auto px-6">

        {events.length === 0 ? (
          <div className="text-center text-neutral-600">
            <p className="text-lg">Timeline events will be loaded here.</p>
          </div>
        ) : (
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-primary-200" aria-hidden="true" />

            <div className="space-y-8">
              {events.map((event, index) => (
                <div key={index} className="relative flex items-start gap-6">
                  {/* Timeline dot */}
                  <div className="flex-shrink-0 w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg">
                    <CalendarIcon className="w-6 h-6" aria-hidden="true" />
                  </div>

                  {/* Content */}
                  <div className="flex-grow bg-white rounded-lg shadow-lg p-6">
                    <div className="flex items-start justify-between mb-3">
                      <h3 className="text-xl font-semibold text-primary-700">{event.year}</h3>
                    </div>
                    <h4 className="text-lg font-medium mb-3">{event.title}</h4>
                    <ul className="space-y-1">
                      {event.points.map((point, i) => (
                        <li key={i} className="text-neutral-700 flex items-start gap-2">
                          <span className="mt-2 shrink-0 w-1.5 h-1.5 rounded-full bg-primary-400" aria-hidden="true" />
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* NOW closing section */}
        <div className="mt-12 border-t-2 border-primary-600 pt-8 text-center">
          <h3 className="text-2xl font-bold text-primary-700 mb-4">NOW — The Choice Before Us</h3>
          <div className="space-y-2 text-neutral-700 text-base leading-relaxed max-w-xl mx-auto">
            <p>When violence can no longer be hidden, the story is controlled.</p>
            <p>When truth threatens power, it is attacked.</p>
            <p>When accountability becomes optional, democracy weakens.</p>
            <p className="font-semibold text-neutral-800 pt-2">
              This is not a break from history. It is its continuation.
            </p>
          </div>
        </div>

      </div>
    </section>
  )
}
